<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="vdp-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="vdpOfferWidgetEnabled">VDP Offer Display
          <i class="pi pi-info-circle"
             pTooltip="When enabled, MPOP Offer data and CTA will be displayed on dealer VDP pages when the data is matched by VIN."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="vdpOfferWidgetEnabled"
          formControlName="vdpOfferWidgetEnabled">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="offerTextColor">Offer Text Color
          <i class="pi pi-info-circle"
             pTooltip="Color used for the standard VDP payment text in the offer widget."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="offerTextColor"
                 type="color"
                 formControlName="offerTextColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('offerTextColor')?.value"
            (input)="form?.get('offerTextColor')?.setValue($any($event.target).value); form?.get('offerTextColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <label class="field-input-label tab-input-label label-field">
        CTA Text Font Size
        <i class="pi pi-info-circle"
           pTooltip="Configure the font size of the main call-to-action text on VDP."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper cta-text-font-size-input" type="number" formControlName="ctaTextFontSize">
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="ctaButtonColor">CTA Button Color
          <i class="pi pi-info-circle"
             pTooltip="Configure the color of the main call-to-action button on VDP."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="ctaButtonColor"
                 type="color"
                 formControlName="ctaButtonColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('ctaButtonColor')?.value"
            (input)="form?.get('ctaButtonColor')?.setValue($any($event.target).value); form?.get('ctaButtonColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
  </div>
</form>
